<template>
  <v-bottom-navigation color="primary" horizontal style="position: sticky">
    <template v-for="item in items">
      <v-btn :key="item.path" :to="item.path">
        <span :key="item.title">{{ item.title }}</span>
        <v-icon :key="item.icon">{{ item.icon }}</v-icon>
      </v-btn>
    </template>
  </v-bottom-navigation>
</template>

<script>
export default {
  data: () => ({
    items: [
      { icon: "mdi-calendar", title: "Mis Reservas", path: "/client/Historic" },
      { icon: "mdi-map-marker", title: "Reservar", path: "/client/Search" },
      { icon: "mdi-account", title: "Perfil", path: "/client/User" },
    ]
  })
};
</script>

<style scoped>
</style>
